<template>
  <v-container class="pa-0 pkc-checklist-container">

    <v-row dense>
      <v-container>
        <ExplorerFiltersRow
          :actions="actions"
          :active-filters="searchFilters"
          :compact-filters="true"
          :enable-filter-button="true"
          :model="modelName"
          :response-filters="responseFilters"
          :search="false"
          @clearAllFilters="clearAllFilters"
          @[$events.EXPLORER_REMOVE_FILTER]="removeFilter"
          @[$events.EXPLORER_SEARCH]="searchByText"
          @[$events.EXPLORER_ACTION_CLICKED]="actionClicked"
        >
          <template v-slot:filters>
            <PKCChecklistTableFilters
              :active-filters="searchFilters"
              :loading="loading"
              @changeFilters="changeFilters"
            />
          </template>
        </ExplorerFiltersRow>
        <DataTable
          :data="dataTableData"
          :data-table-options="dataTableOptions"
          :headers="dataTableHeaders"
          :loading="loading"
          :model="modelName"
          @open_original_process="openOriginalProcess"
          @[$events.DATA_TABLE_REFRESH]="find"
          @[$events.DATA_TABLE_OPEN]="$emit('openItem', $event)"
        />
      </v-container>
    </v-row>
    <ExportDataTable
      v-if="showExportDialog"
      :fields="dataTableHeaders"
      :model="modelName"
      :response_filters="responseFilters"
      :service="service_"
      @close="showExportDialog=false"
    />
  </v-container>
</template>

<script>
  import helpers_resolution from '@/plugins/helpers_resolution'
  import service_protocol from '@/services/service_protocol'
  import service_user from '@/services/service_user'
  import DataTable from '@/components/repository/tables/DataTable'
  import {
    P_EXPORT, P_PROCESSES
  } from '@/constants/group_permissions'
  import ExportDataTable from '@/components/repository/tables/dataTable/ExportDataTable'
  import { datatableMixin } from '@/mixins/dataTable'
  import store from '@/store'
  import icons from '@/constants/icons'
  import vuex_management from '@/store/modules/sections/vuex_management'
  import ExplorerFiltersRow from '@/components/repository/explorers/ExplorerFiltersRow.vue'
  import PKCChecklistTableFilters
    from '@/components/management/processManagement/components/PKCChecklistTableFilters.vue'
  import model_checklist from '@/constants/models/pkc/model_checklist'
  import service_management from '@/services/service_management'
  import service_processes from '@/services/service_processes'
  import model_pkcProcess from '@/constants/models/pkc/model_pkcProcess'

  const modelName = 'Checklists'
  const dataTableConfig = {
    findOnCreate: false,
    options: {
      rpp: helpers_resolution.getTableRowsPerPage(),
      sortDesc: [true],
      page: 1,
      sortBy: [model_checklist.fields.CREATION_TIMESTAMP]
    },
    finder: service_management.getPKCChecklist,
    vuex: {
      state: store.state[vuex_management.constants.NAMESPACE][vuex_management.constants.S_CHECKLIST_SEARCH_FILTERS],
      setter: vuex_management.constants.NAMESPACE + '/' + vuex_management.constants.A_SET_SEARCH_FILTERS
    }
  }
  export default {
    name: 'PKCChecklistsTable',
    components: {
      ExplorerFiltersRow,
      ExportDataTable,
      DataTable,
      PKCChecklistTableFilters
    },
    mixins: [datatableMixin(dataTableConfig)],
    data() {
      return {
        modelName,
        service_protocol,
        dataTableHeaders: [
          {
            text: '',
            value: model_checklist.fields.STATUS,
            sortable: true,
            type: 'process_management_status',
            width: '40px'
          },
          { text: 'Proceso', value: model_checklist.fields.PROCESS_NAME, type: 'checklist_link', width: '25%' },
          { text: 'P. Code', value: model_checklist.fields.PROCESS_CODE, width: '8%' },
          { text: 'V.', value: model_checklist.fields.VERSION, hide: true, align: ' d-none' },
          { text: '', value: model_checklist.fields.ID, hide: true, align: ' d-none' },
          { text: 'Cuenta Raíz', value: model_checklist.fields.MASTER_ACCOUNT_NAME, width: '15%' },
          { text: 'Subcuenta', value: model_checklist.fields.SUBACCOUNT_NAME, width: '15%' },
          { text: 'Usuario', value: model_checklist.fields.USERNAME, type: 'app_center_user', width: '15%' },
          {
            text: 'Fecha de creación',
            value: model_checklist.fields.CREATION_TIMESTAMP,
            type: 'timestamp_date',
            width: '20%',
            sortable: true
          },
          {
            text: '',
            value: 'actions',
            align: 'center',
            sortable: false,
            custom: true,
            width: '40px',
            actions: () => {

              let entities = []

              entities.push({
                id: 'data_table_open',
                icon: icons.I_VIEW,
                title: 'Ver detalles',
                enabled: true
              })

              if (service_user.checkGroupPermission(P_PROCESSES)) {
                entities.push({
                  id: 'open_original_process',
                  icon: icons.I_PROCESS,
                  title: 'Ir al proceso',
                  enabled: true
                })
              }
              return entities

            }
          }
        ],
        loading: false,
        checklistSelected: null
      }
    },
    computed: {
      searchFilters: {
        get() {
          return this.$store.state[vuex_management.constants.NAMESPACE][vuex_management.constants.S_CHECKLIST_SEARCH_FILTERS]
        },
        set(val) {
          this.$store.dispatch(`${vuex_management.constants.NAMESPACE}/${vuex_management.constants.A_SET_CHECKLIST_SEARCH_FILTERS}`, val)
        }
      },
      actions() {
        let entities = []
        if (service_user.checkGroupPermission(P_EXPORT)) {
          entities.push({
            id: 'export',
            icon: this.$icons.I_EXPORT,
            text: 'Exportar datos',
            enabled: true
          })
        }

        return entities
      }

    },
    created() {
      this.find()
    },
    methods: {
      changeFilters(new_filters) {
        if (JSON.stringify(this.searchFilters) !== JSON.stringify(new_filters)) {
          this.searchFilters = new_filters
          this.find()
        }
      },
      clearAllFilters() {
        this.searchFilters = {}
        this.find()
      },
      actionClicked(action_id) {
        if (action_id === 'export') {
          this.showExportDialog = true
        }
      },

      closeDialog() {
        this.checklistSelected = null
        this.find()
      },
      openOriginalProcess(item) {
        service_processes.openProcess(item[model_pkcProcess.PROCESS_CODE], item[model_pkcProcess.NAME])
      }
    },
    filters: {}
  }
</script>

<style lang="scss">
  @import "../../../assets/styles/resources/colors";
  @import "../../../assets/styles/resources/variables";

</style>